






































































































































































































import {
  addMonths,
  anyToDate,
  differenceInCalendarMonths,
  differenceInDays,
  formatDate,
  getDaysInMonth,
  isBefore,
  max,
  min,
  setDate,
  startOfDay,
  startOfMonth,
} from 'vtils/date'
import {
  apiCommodityTravelSkuList,
  apiOrderExchangeGoodsExchangeGoodsPreOrder,
  ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
} from '@/api'
import { bookGoodsModelProvider } from '../model'
import { computed, nextTick, ref } from '@vue/composition-api'
import { currentSaleChannelId } from '@/channel'
import { defineClassComponent, useQuery } from '@/hooks'
import { groupBy, minBy, range } from 'vtils'
import { isWithinInterval } from 'vtils/date'
import { navigateTo } from '@/router'
import { requiredDeep, submit, Track } from '@/utils'

type CalendarData = Array<{
  title: string
  startDayOfWeek: number
  days: Array<{
    key: string
    value: number
    desc: string
    disabled: boolean
    times: Array<{
      key: string
      startTime: string
      endTime: string
      value: string
      disabled: boolean
      skuId: string
      price: number
      stock: number
    }>
  }>
}>

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      query = useQuery<{
        goodsId: string
        exchangeCommodityId: string
        type: string
        skuId: string
        parentOrderNo: string
      }>()

      seckillData = computed(() => this.bookGoodsModel.value.seckillData)

      // 秒杀信息
      seckillInfo = computed(() => this.bookGoodsModel.value.seckillInfo)

      // 兑换商品sku信息
      virtualSkuInfo = computed(
        () => this.bookGoodsModel.value.virtualSkuInfo,
      )

      showDatePicker = ref(false)

      calendarData = ref<CalendarData>([])

      timesMap = computed(() =>
        this.calendarData.value.reduce<
          Record<string, CalendarData[0]['days'][0]['times']>
        >((res, item) => {
          item.days.forEach(day => {
            res[day.key] = day.times
          })
          return res
        }, {}),
      )

      timeMap = computed(() =>
        this.calendarData.value.reduce<
          Record<string, CalendarData[0]['days'][0]['times'][0]>
        >((res, item) => {
          item.days.forEach(day => {
            day.times.forEach(time => {
              res[time.key] = time
            })
          })
          return res
        }, {}),
      )

      selectedDay = ref('')

      isSelectedDayRange = computed(
        () => this.bookGoodsModel.value.isDateInterval === 1,
      )
      selectedDayRange = ref<string[]>([])
      selectedDayRangeInfo = computed(() => {
        return {
          start: formatDate(
            anyToDate(this.selectedDayRange.value[0]),
            'm月d日',
          ),
          end: formatDate(
            anyToDate(this.selectedDayRange.value[1]),
            'm月d日',
          ),
          total: differenceInDays(
            anyToDate(this.selectedDayRange.value[1]),
            anyToDate(this.selectedDayRange.value[0]),
          ),
        }
      })

      timesData = computed(
        () => this.timesMap.value[this.selectedDay.value] || [],
      )

      selectedTime = ref('')

      handleBuyClick = async () => {
        if (this.query.type === 'exchange') {
          if (!this.virtualSkuInfo.value.cutStock) {
            return
          }

          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,

            skuInfo: [
              {
                commodityId: this.bookGoodsModel.value.goodsId,
                count: 1,
                sellChannelId: currentSaleChannelId,
                skuId: this.query.skuId,
                stockDate: undefined,
                stockEndDate: undefined,
                startTime: undefined,
                endTime: undefined,
              },
            ],
          }
          const preOrderRequestData1: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest =
            {
              commodityId: this.bookGoodsModel.value.goodsId,
              exchangeCommodityId: this.query.exchangeCommodityId,
              parentOrderNo: this.query.parentOrderNo,
              skuId: this.query.skuId,
            }

          const res = await apiOrderExchangeGoodsExchangeGoodsPreOrder(
            preOrderRequestData1,
          )

          nextTick(() => {
            navigateTo('TravelOrderPlace', {
              sourceType: this.query.type,
              preOrderRequestData: JSON.stringify(preOrderRequestData),
              preOrderRequestData1: JSON.stringify(preOrderRequestData1),
              preOrderResponseData: JSON.stringify(res),
            })
          })
        } else {
          if (this.bookGoodsModel.value.isDateStock) {
            const latestSkuList = await apiCommodityTravelSkuList({
              skuId: this.bookGoodsModel.value.goodsId,
              areaCode: '',
              cityCode: '',
              provinceCode: '',
            }).then(requiredDeep)
            const dateList = latestSkuList.map(item =>
              anyToDate(item.stockDate),
            )
            const timeMap = groupBy(latestSkuList, item => item.stockDate)
            const minDate = min(dateList)
            const maxDate = max(dateList)
            const diffMonth = differenceInCalendarMonths(maxDate, minDate)
            const baseDate = startOfMonth(minDate)
            const calendarData: CalendarData = []
            let selectedDay = ''
            let selectedTime = ''
            for (let i = 0; i <= diffMonth; i++) {
              const monthDate = addMonths(baseDate, i)
              calendarData.push({
                title: formatDate(monthDate, 'yyyy年m月'),
                startDayOfWeek: monthDate.getDay() || 7,
                days: range(1, getDaysInMonth(monthDate) + 1).map(
                  dayOfMonth => {
                    const dayDate = setDate(monthDate, dayOfMonth)
                    const dateKey = `${formatDate(dayDate, 'yyyy-mm-dd')}`
                    const minPrice = minBy(
                      timeMap[dateKey] || [],
                      item => item.sellPrice,
                    )?.sellPrice
                    const desc = minPrice != null ? `¥${minPrice}起` : ''

                    // 开始时间逻辑
                    let expired = false
                    if (
                      +this.bookGoodsModel.value.isValidDay === 0 &&
                      this.bookGoodsModel.value.advanceDay
                    ) {
                      if (
                        differenceInDays(
                          startOfDay(dayDate),
                          startOfDay(new Date()),
                        ) < this.bookGoodsModel.value.advanceDay
                      ) {
                        expired = true
                      }
                    }

                    const disabled = expired || minPrice == null
                    if (!selectedDay && !disabled) {
                      selectedDay = dateKey
                    }
                    return {
                      key: dateKey,
                      value: dayOfMonth,
                      desc: desc,
                      disabled: disabled,
                      times: (timeMap[dateKey] || []).map(item => {
                        const timeKey = `${dateKey} ${item.startTime}`
                        if (selectedDay === dateKey && !selectedTime) {
                          selectedTime = timeKey
                        }
                        return {
                          key: timeKey,
                          startTime: item.startTime as any,
                          endTime: item.endTime as any,
                          value: `${String(item.startTime).replace(
                            /:\d+$/,
                            '',
                          )}-${String(item.endTime).replace(/:\d+$/, '')}`,
                          disabled: false,
                          skuId: item.skuId,
                          price: item.sellPrice,
                          stock: item.surplusStock,
                        }
                      }),
                    }
                  },
                ),
              })
            }
            this.calendarData.value = calendarData
            this.selectedDay.value = selectedDay
            this.selectedTime.value = selectedTime
            this.showDatePicker.value = true
          } else {
            this.handleDateConfirm()
          }
        }
      }

      checkDayInclusion = (day: CalendarData[0]['days'][0]) => {
        if (
          this.isSelectedDayRange.value &&
          this.selectedDayRange.value[0] &&
          this.selectedDayRange.value[1]
        ) {
          return isWithinInterval(anyToDate(day.key), {
            start: anyToDate(this.selectedDayRange.value[0]),
            end: anyToDate(this.selectedDayRange.value[1]),
          })
        }
        return false
      }

      handleDayClick = (day: CalendarData[0]['days'][0]) => {
        if (this.isSelectedDayRange.value) {
          if (this.selectedDayRange.value.includes(day.key)) {
            this.selectedDayRange.value.splice(
              this.selectedDayRange.value.indexOf(day.key),
              1,
            )
          } else if (this.selectedDayRange.value.length === 0) {
            this.selectedDayRange.value.push(day.key)
          } else if (this.selectedDayRange.value.length === 1) {
            if (
              isBefore(
                anyToDate(day.key),
                anyToDate(this.selectedDayRange.value[0]),
              )
            ) {
              this.selectedDayRange.value.unshift(day.key)
            } else {
              this.selectedDayRange.value.push(day.key)
            }
          } else {
            if (
              isBefore(
                anyToDate(day.key),
                anyToDate(this.selectedDayRange.value[0]),
              )
            ) {
              this.selectedDayRange.value.splice(0, 1, day.key)
            } else {
              this.selectedDayRange.value.splice(1, 1, day.key)
            }
          }
        } else {
          this.selectedDay.value = day.key
          this.selectedTime.value =
            (this.timesMap.value[this.selectedDay.value][0] &&
              this.timesMap.value[day.key][0].key) ||
            ''
        }
      }

      handleDateConfirm = () => {
        submit(async $ => {
          if (
            this.bookGoodsModel.value.isDateStock &&
            this.isSelectedDayRange.value &&
            this.selectedDayRange.value.length !== 2
          ) {
            return $.fail('请选择日期')
          }

          Track.pushEvent({
            type: 'click',
            name: '立即购买',
            id: 'JiaGou',
            extra: {
              commodity_id: this.bookGoodsModel.value.commodityId,
              commodity_name: this.bookGoodsModel.value.commodityTitle,
              commodity_tag: '',
              original_price: this.bookGoodsModel.value.dashPrice,
              present_price: this.bookGoodsModel.value.lowestPrice,
              discount_price:
                this.bookGoodsModel.value.dashPrice -
                this.bookGoodsModel.value.lowestPrice,
              store_id: this.bookGoodsModel.value.merchantId,
              store_name: this.bookGoodsModel.value.merchantName,
              sku_id:
                this.bookGoodsModel.value.isDateStock &&
                !this.isSelectedDayRange.value
                  ? this.timeMap.value[this.selectedTime.value].skuId
                  : this.bookGoodsModel.value.skuList[0].skuId,
              sku_name: '',
              additional_purchase_type: '立即购买',
            },
          })
          $.start()
          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,
            skuInfo: [
              {
                commodityId: this.bookGoodsModel.value.goodsId,
                count: 1,
                sellChannelId: currentSaleChannelId,
                skuId:
                  this.bookGoodsModel.value.isDateStock &&
                  !this.isSelectedDayRange.value
                    ? this.timeMap.value[this.selectedTime.value].skuId
                    : this.bookGoodsModel.value.skuList[0].skuId,
                stockDate: this.bookGoodsModel.value.isDateStock
                  ? this.isSelectedDayRange.value
                    ? this.selectedDayRange.value[0]
                    : this.selectedDay.value
                  : undefined,
                stockEndDate:
                  this.bookGoodsModel.value.isDateStock &&
                  this.isSelectedDayRange.value
                    ? this.selectedDayRange.value[1]
                    : undefined,
                startTime:
                  this.bookGoodsModel.value.isDateStock &&
                  !this.isSelectedDayRange.value
                    ? (this.timeMap.value[this.selectedTime.value]
                        .startTime as any)
                    : undefined,
                endTime:
                  this.bookGoodsModel.value.isDateStock &&
                  !this.isSelectedDayRange.value
                    ? (this.timeMap.value[this.selectedTime.value]
                        .endTime as any)
                    : undefined,
              },
            ],
          }
          const res = await apiTradeGeneralTradePreOrder(preOrderRequestData)
          this.showDatePicker.value = false
          nextTick(() => {
            navigateTo('TravelOrderPlace', {
              preOrderRequestData: JSON.stringify(preOrderRequestData),
              preOrderResponseData: JSON.stringify(res),
            })
          })
        })
      }
    },
)
